/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import SaveSouscriptionCompanyMutation from '../graphql/mutations/SaveSouscriptionCompanyMutation.js';

export const useSaveSouscriptionCompanyMutation = () => {
  return useCommitMutation(SaveSouscriptionCompanyMutation, {
    dataProp: 'saveSouscriptionCompany_M_souscription_company'
  });
};

export default useSaveSouscriptionCompanyMutation;
